import api from 'api/apiInstance';

import { clientCaseVulnerabilityAssessmentsDraftApi } from './draft';
import { clientCaseVulnerabilityAssessmentsLastApi } from './last';
import type {
  VulnerabilityAssessmentResponse,
  VulnerabilityAssessmentsResponse,
  VulnerabilityAssessmentUpsertOptions,
  VulnerabilityConfirmResponse,
  VulnerabilityScanResponse,
} from './types';

export function clientCaseVulnerabilityAssessmentsApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<VulnerabilityAssessmentsResponse>(path, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        skipRedirect: true,
      }),
    last: () => clientCaseVulnerabilityAssessmentsLastApi(`${path}/last`),
    // The pending AI draft (AI sub-flag gated). Consumed only by the scan panel.
    draft: () => clientCaseVulnerabilityAssessmentsDraftApi(`${path}/draft`),
    // Enqueue an AI scan → 202. No record up-front: the worker drafts an
    // UNCONFIRMED assessment only on success (fail-closed). The FE then polls
    // `draft` for the suggestion to appear.
    scan: () => ({
      path: `${path}/scan`,
      POST: () =>
        api.post<VulnerabilityScanResponse>(`${path}/scan`, undefined, {
          // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
          skipRedirect: true,
        }),
    }),
    // Named-human confirmation of an AI draft (SM&CR sign-off): records
    // who/when and unblocks outbound comms server-side. Returns the promoted
    // assessment. One-time — a second attempt is refused (422).
    confirm: (assessmentId: number | string) => ({
      path: `${path}/${assessmentId}/confirm`,
      PUT: () =>
        api.put<VulnerabilityConfirmResponse>(`${path}/${assessmentId}/confirm`, undefined, {
          // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
          skipRedirect: true,
        }),
    }),
    // Upsert: the BE updates the latest assessment or creates the first one,
    // stamping typed recorded_by/recorded_at (SM&CR named owner) server-side.
    PUT: (attributes: VulnerabilityAssessmentUpsertOptions) =>
      api.put<VulnerabilityAssessmentResponse>(
        path,
        { data: { attributes } },
        {
          // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
          skipRedirect: true,
        }
      ),
  };
}
